import Promise from 'bluebird'
import schemaValErrors from '../lib/preparations/schema-validation-errors.js'

export default function (data) {
  return new Promise((resolve, reject) => {
    resolve( schemaValErrors(data) );
  });
};
